export default __webpack_public_path__ + "static/media/talk-to-us.3ed9d388.png";